import { classNames } from '@commenda/utils';

type InputTextAccentProp = 'error' | 'hint';

const InputText = ({
  children,
  accent,
}: {
  children: React.ReactNode;
  accent: InputTextAccentProp;
}) => {
  return (
    <div
      className={classNames(
        'txt-small-regular text-wrap flex items-center',
        accent === 'error' ? 'text-text-error' : 'text-text-tertiary'
      )}
    >
      {children}
    </div>
  );
};

InputText.displayName = 'InputText';

export { InputText };
